// client/src/components/notes/noteTypes.js
// What a note can be associated with, and where each association links to.

export const NOTE_REF_TYPES = ['event', 'event_item', 'event_action', 'post', 'campaign'];

// [i18n key, English fallback] — singular and plural.
export const NOTE_TYPE_LABELS = {
  event: ['notes.type.event', 'Event'],
  event_item: ['notes.type.eventItem', 'Event item'],
  event_action: ['notes.type.eventAction', 'Event action'],
  post: ['notes.type.post', 'Post'],
  campaign: ['notes.type.campaign', 'Campaign'],
};

export const NOTE_TYPE_PLURALS = {
  event: ['notes.types.event', 'Events'],
  event_item: ['notes.types.eventItem', 'Event items'],
  event_action: ['notes.types.eventAction', 'Event actions'],
  post: ['notes.types.post', 'Posts'],
  campaign: ['notes.types.campaign', 'Campaigns'],
};

export const typeLabel = (t, type) => {
  const [key, fallback] = NOTE_TYPE_LABELS[type] || [null, type];
  return key ? t(key, fallback) : fallback;
};

export const typePlural = (t, type) => {
  const [key, fallback] = NOTE_TYPE_PLURALS[type] || [null, type];
  return key ? t(key, fallback) : fallback;
};

export const linkKey = (l) => `${l.type}:${l.id}`;

/** In-app route for an associated record, or null when there is nowhere to go. */
export function linkPath(tenant, l) {
  if (!l || l.missing) return null;
  switch (l.type) {
    case 'event': return `/${tenant}/${l.eventId || l.id}/eventDetail`;
    case 'event_item': return l.eventId ? `/${tenant}/${l.eventId}/${l.id}/eventItemDetail` : null;
    case 'event_action': return l.eventId && l.itemId ? `/${tenant}/${l.eventId}/${l.itemId}/actionDetail` : null;
    case 'post': return `/${tenant}/post/${l.id}`;
    case 'campaign': return `/${tenant}/campaigns/${l.id}`;
    default: return null;
  }
}

/** Flatten the grouped /targets payload into one array. */
export const flattenTargets = (grouped) =>
  NOTE_REF_TYPES.flatMap((type) => (grouped && Array.isArray(grouped[type]) ? grouped[type] : []));
